import React from "react";
import { Icon } from "semantic-ui-react";

const AnalysisWarnings = (props) => {
	const { analysis } = props;

	const warning = (label, text) => (
		<div style={{ color: "#a53a12", fontWeight: 600 }}>
			<Icon className="warningIcon" size="small" name="warning" circular style={{ position: "relative", bottom: 2, marginLeft: 3 }} />
			{label}{" "}
			{text && (
				<span style={{ color: "black" }}>
					{text.includes("\n") ? (
						<div style={{ paddingLeft: "32px" }}>{text.split(/(?:\r\n|\r|\n)/g).reduce((prev, curr) => [prev, <br />, curr])}</div>
					) : (
						text
					)}
				</span>
			)}
		</div>
	);

	return (
		<div>
			{analysis.special_diet && warning("Régime alimentaire : ", `${analysis.diet || "non précisé"}`)}
			{analysis.home_prohibited && warning("Interdit à domicile")}
			{analysis.required_consent && warning("Formulaire de consentement requis")}
			{analysis.subcontracting && warning("Analyse sous-traitée : ", analysis.subcontracter)}
			{analysis.taking_note !== null && analysis.taking_note !== "" && warning(`Note pour le prélèvement :`, analysis.taking_note)}
		</div>
	);
};

export default AnalysisWarnings;
